export default "__VITE_ASSET__05f92e09__"